export default __webpack_public_path__ + "static/media/gallery-wip-pommel_05.83a76dbe.jpg";